(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-clear-button"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cc-cart-clear')) {
    customElements.define('cc-cart-clear', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.button = this.querySelector('button');
        this.error = this.querySelector('[role="alert"]');
        if (!this.button || !this.error) return;
        this.initialized = true;
        this.label = this.button.textContent.trim();
        this.button.disabled = false;
        this.button.addEventListener('click', () => this.clearCart());
      }

      async clearCart() {
        if (this.busy) return;
        this.busy = true;
        this.button.disabled = true;
        this.button.textContent = this.dataset.clearing;
        this.setAttribute('aria-busy', 'true');
        this.error.hidden = true;
        this.error.textContent = '';
        try {
          const cartUrl = this.dataset.cartUrl.replace(/\/$/, '');
          const response = await fetch(`${cartUrl}/clear.js`, {
            method: 'POST',
            credentials: 'same-origin',
            headers: { Accept: 'application/json' }
          });
          if (!response.ok) throw new Error('Clear request failed');
          const cart = await response.json();
          if (cart.item_count !== 0) throw new Error('Cart is not empty');
          window.location.assign(this.dataset.cartUrl);
        } catch (error) {
          this.error.textContent = this.dataset.error;
          this.error.hidden = false;
          this.button.disabled = false;
          this.button.textContent = this.label;
          this.removeAttribute('aria-busy');
          this.busy = false;
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["locations-opening-status"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cc-location-hours')) {
    customElements.define('cc-location-hours', class extends HTMLElement {
      constructor() {
        super();
        this.refresh = this.refresh.bind(this);
        this.formatter = new Intl.DateTimeFormat('en-GB', {
          timeZone: 'Europe/Paris', weekday: 'short', hour: '2-digit',
          minute: '2-digit', hourCycle: 'h23'
        });
      }

      connectedCallback() {
        this.refresh();
        this.timer = window.setInterval(this.refresh, 30000);
        document.addEventListener('visibilitychange', this.refresh);
        window.addEventListener('pageshow', this.refresh);
      }

      disconnectedCallback() {
        window.clearInterval(this.timer);
        document.removeEventListener('visibilitychange', this.refresh);
        window.removeEventListener('pageshow', this.refresh);
      }

      readSchedule(card) {
        const days = ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi'];
        const schedule = new Map();
        for (const row of card.querySelectorAll('.cc-store-hours li')) {
          const spans = row.querySelectorAll('span');
          if (spans.length !== 2) return null;
          const label = spans[0].textContent.trim();
          const day = days.indexOf(label.toLocaleLowerCase('fr-FR'));
          if (day < 0 || schedule.has(day)) return null;
          const text = spans[1].textContent.trim().toLocaleLowerCase('fr-FR');
          const intervals = [];
          if (!/^ferm[ée]e?\s*$/.test(text)) {
            for (const slot of text.split('/')) {
              const match = slot.trim().match(/^(\d{1,2})\s*[h:]\s*(\d{2})?\s*(?:[-–—]|à)\s*(\d{1,2})\s*[h:]\s*(\d{2})?$/);
              if (!match) return null;
              const startHour = Number(match[1]);
              const startMinute = Number(match[2] || 0);
              const endHour = Number(match[3]);
              const endMinute = Number(match[4] || 0);
              if (startHour > 23 || endHour > 24 || startMinute > 59 || endMinute > 59 || (endHour === 24 && endMinute !== 0)) return null;
              const start = startHour * 60 + startMinute;
              const end = endHour * 60 + endMinute;
              if (start === end) return null;
              intervals.push({ start, end });
            }
          }
          intervals.sort((a, b) => a.start - b.start);
          schedule.set(day, { label: label.toLocaleLowerCase('fr-FR'), intervals, row });
        }
        return schedule.size === 7 ? schedule : null;
      }

      clock(minutes) {
        return `${Math.floor(minutes / 60)}h${String(minutes % 60).padStart(2, '0')}`;
      }

      getStatus(schedule, day, minute) {
        const today = schedule.get(day).intervals;
        const previous = schedule.get((day + 6) % 7).intervals;
        const active = today.find(slot => minute >= slot.start && (slot.end < slot.start || minute < slot.end))
          || previous.find(slot => slot.end < slot.start && minute < slot.end);
        if (active) {
          return { open: true, text: this.dataset.openUntil.replace('[time]', this.clock(active.end)) };
        }
        const later = today.find(slot => slot.start > minute);
        if (later) {
          return { open: false, text: this.dataset.opensToday.replace('[time]', this.clock(later.start)) };
        }
        for (let offset = 1; offset <= 7; offset += 1) {
          const next = schedule.get((day + offset) % 7);
          if (next.intervals.length) {
            return { open: false, text: this.dataset.opensLater.replace('[day]', next.label).replace('[time]', this.clock(next.intervals[0].start)) };
          }
        }
        return { open: false, text: this.dataset.closed };
      }

      refresh() {
        if (!this.parentElement) return;
        const parts = Object.fromEntries(this.formatter.formatToParts(new Date()).map(part => [part.type, part.value]));
        const day = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].indexOf(parts.weekday);
        const minute = Number(parts.hour) * 60 + Number(parts.minute);
        if (day < 0 || !Number.isFinite(minute)) return;
        this.parentElement.querySelectorAll('.cc-store-card').forEach(card => {
          const status = card.querySelector('.cc-store-status');
          if (!status) return;
          const schedule = this.readSchedule(card);
          if (!schedule) {
            status.textContent = this.dataset.hoursLabel;
            status.classList.remove('is-open', 'is-closed');
            status.removeAttribute('data-hours-ready');
            return;
          }
          const result = this.getStatus(schedule, day, minute);
          status.textContent = result.text;
          status.classList.toggle('is-open', result.open);
          status.classList.toggle('is-closed', !result.open);
          status.setAttribute('data-hours-ready', '');
          status.title = this.dataset.hoursNote;
          status.setAttribute('role', 'status');
          status.setAttribute('aria-atomic', 'true');
          for (const [index, entry] of schedule) {
            entry.row.classList.toggle('is-current-day', index === day);
            if (index === day) entry.row.setAttribute('aria-current', 'date');
            else entry.row.removeAttribute('aria-current');
          }
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
